import React, { useCallback, useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import CommerceExtensionsPanel from '../components/ecommerce/CommerceExtensionsPanel';

const API_URL = (process.env.REACT_APP_BACKEND_URL && process.env.REACT_APP_BACKEND_URL !== '')
  ? process.env.REACT_APP_BACKEND_URL
  : '';

/**
 * Light-themed Commerce+ shell for the operator cockpit iframe.
 * Matches the genre dashboard (dash-layout) look and feel.
 */
const OperatorCommerceEmbed = () => {
  const { websiteId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get('tab') || 'currency';
  const token = typeof window !== 'undefined' ? localStorage.getItem('token') : '';
  const [orders, setOrders] = useState([]);

  const loadOrders = useCallback(async () => {
    if (!token || !websiteId) return;
    try {
      const res = await fetch(`${API_URL}/api/websites/${websiteId}/orders`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) setOrders(await res.json());
    } catch {
      /* optional */
    }
  }, [websiteId, token]);

  useEffect(() => {
    loadOrders();
  }, [loadOrders]);

  const onTabChange = (nextTab) => {
    setSearchParams({ tab: nextTab }, { replace: true });
  };

  if (!token) {
    return (
      <div className="min-h-screen bg-[#08080b] flex items-center justify-center text-zinc-400 p-6">
        Sign in to manage Commerce+ settings.
      </div>
    );
  }

  return (
    <div
      className="min-h-screen text-white"
      style={{ background: 'radial-gradient(1100px 560px at 100% -10%, rgba(139,92,246,.07), transparent 60%), #08080b' }}
    >
      <main className="p-8 max-w-5xl mx-auto">
        <h2 className="text-2xl font-extrabold text-white tracking-tight">Commerce+</h2>
        <p className="text-zinc-400 text-sm mt-1 mb-6">
          Currency, Shopify/Woo sync, and local delivery settings for your storefront.
        </p>
        <CommerceExtensionsPanel
          websiteId={websiteId}
          token={token}
          API_URL={API_URL}
          orders={orders}
          onRefresh={loadOrders}
          initialSection={tab}
          onSectionChange={onTabChange}
          theme="dark"
        />
      </main>
    </div>
  );
};

export default OperatorCommerceEmbed;
